var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"256px","display":"flex"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.themeLogo || require('@/assets/images/logo.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }